var _g, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSylized9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5652_8965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.23438 12.9046C2.23438 6.88216 7.11626 2.00003 13.1393 2.00003C19.161 2.00003 24.0429 6.88216 24.0429 12.9046C24.0429 18.9269 19.161 23.809 13.1393 23.809C7.11626 23.809 2.23438 18.9269 2.23438 12.9046Z",
    fill: "#7BB65C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7344 15.375C16.2344 19.5002 9.73438 19.5003 9.23438 15.3751L16.7344 15.375Z",
    fill: "black",
    stroke: "black",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.636 10.1074L11.6368 10.0965C11.6368 9.41374 11.1424 8.78855 10.3998 8.78855C9.80994 8.78855 9.46817 9.21257 9.35106 9.60952C9.23482 9.21257 8.89217 8.78855 8.3023 8.78855C7.55975 8.78855 7.06616 9.41374 7.06616 10.0965V10.1074C7.06269 10.256 7.06616 11.7676 9.35019 12.9997V13L9.35106 12.9998V13L9.35193 12.9998V13V12.9997C11.6368 11.7676 11.6403 10.256 11.636 10.1074Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3357 10.1074V10.0965C19.3357 9.41374 18.8421 8.78855 18.0995 8.78855C17.5097 8.78855 17.1679 9.21257 17.0508 9.60952C16.9345 9.21257 16.5919 8.78855 16.002 8.78855C15.2595 8.78855 14.7659 9.41374 14.7659 10.0965V10.1074C14.7624 10.256 14.7659 11.7676 17.0499 12.9997V13L17.0508 12.9998V13L17.0516 12.9998V13V12.9997C19.3365 11.7676 19.34 10.256 19.3357 10.1074Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5652_8965",
    x: 0.34469,
    y: 0.582736,
    width: 25.588,
    height: 25.5883,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.472421,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_5652_8965"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.472421
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.708632
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5652_8965"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5652_8965",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSylized9);
export default __webpack_public_path__ + "static/media/sylized_9.d2c81d33e9a4b274610e8bf12571faa1.svg";
export { ForwardRef as ReactComponent };